import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-our-partners',
  templateUrl: './our-partners.component.html',
  styleUrls: ['./our-partners.component.scss']
})
export class OurPartnersComponent implements OnInit {
  titleSectionProp: any = {
    class: 'text-center iq-title-box-2',
    title: 'OUR_PARTNERS',
    subTitle: 'Our Clients',
    titleIcon: ''
  };

  Images: any[] = [
    { image: '../../assets/images/client/01.svg'},
    { image: '../../assets/images/client/02.png'},
    { image: '../../assets/images/client/03.png'},
    { image: '../../assets/images/client/04.png'},
    { image: '../../assets/images/client/05.png'},
    { image: '../../assets/images/client/06.png'},
    { image: '../../assets/images/client/07.png'},
    { image: '../../assets/images/client/08.png'},
    { image: '../../assets/images/client/09.png'},
    { image: '../../assets/images/client/10.png'},
    { image: '../../assets/images/client/11.png'},
    { image: '../../assets/images/client/12.png'},
    { image: '../../assets/images/client/13.png'},
    { image: '../../assets/images/client/14.png'},
    { image: '../../assets/images/client/15.png'},
    { image: '../../assets/images/client/16.png'},
    { image: '../../assets/images/client/17.png'},
    { image: '../../assets/images/client/18.png'}
  ];



  constructor() { }

  ngOnInit(): void {
  }

}
